<!-- Ventana de busqueda de maestros: misma cabecera, cuerpo y pie que los demas modales (3.0). -->
<div libDialogHeader>
  <div class="cab">
    <span class="cab__icono" aria-hidden="true"
      ><lib-icon [name]="config().icono ?? 'Search'" [size]="18"
    /></span>
    <h3 class="cab__titulo">{{ config().tituloKey | translate }}</h3>
  </div>
  <button
    type="button"
    class="cab__cerrar"
    [attr.aria-label]="'ACTIONS.CANCEL' | translate"
    (click)="cancelar()"
  >
    <lib-icon name="X" [size]="16" />
  </button>
</div>

<div libDialogBody class="cuerpo">
  @if (fallo()) {
    <div class="fallo" role="alert">
      <lib-icon name="CircleAlert" [size]="16" aria-hidden="true" />
      <span>{{ 'COMMON.MESSAGES.ERROR.UNEXPECTED' | translate }}</span>
      <lib-button variant="outline" (clicked)="reintentar()">{{
        'ACTIONS.RETRY' | translate
      }}</lib-button>
    </div>
  }
  <lib-smart-table
    [config]="tabla()"
    [data]="vista()"
    [loading]="cargando()"
    [totalElements]="total()"
    [selectedIds]="idsElegidos()"
    (queryChange)="consultar($event)"
    (rowClick)="elegirFila($event)"
    (selectionChange)="marcar($event)"
  />
</div>

<lib-dialog-footer>
  <lib-button variant="outline" (clicked)="cancelar()">{{
    'ACTIONS.CANCEL' | translate
  }}</lib-button>
  @if (config().multiple) {
    <lib-button variant="primary" [disabled]="!cuantos()" (clicked)="aceptar()">
      {{ 'ACTIONS.ACCEPT' | translate }} ({{ cuantos() }})
    </lib-button>
  }
</lib-dialog-footer>
